module.exports = __webpack_public_path__ + "img/1783501741652.c2643069.webp";